import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiySchedulePickup from "./component";
import { getPickupSlots, setActiveTab } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        doctet,
        activeTab,
        pickupDetail
    }
}) => ({
    inspectionResponse,
    doctet,
    activeTab,
    pickupDetail
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPickupSlotsConnect: getPickupSlots,
    setActiveTabConnect: setActiveTab
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiySchedulePickup);
